// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2222732d","726":"028b555c"}[chunkId] + ".chunk.js";
};